/**
 * ============================================================================
 *  useSnapToggle — 节点对齐吸附开关（localStorage + 自定义事件广播）
 * ============================================================================
 *
 * 左下角磁铁按钮控制吸附开关，EditorPage 的拖拽逻辑读取该状态决定是否吸附。
 * 两者通过 localStorage + 广播事件解耦，同时持久化记住用户选择。
 *
 * 默认开启（首次无 localStorage 记录时返回 true）。
 *
 * 数据流：
 *   localStorage('snap_enabled') ← setSnapEnabled()
 *   ↓ 广播 SNAP_ENABLED_CHANGED
 *   各处监听 → 同步状态
 */
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'snap_enabled';
export const SNAP_ENABLED_CHANGED = 'snap_enabled_changed';

export function getSnapEnabled() {
  // 默认开启：只有显式存了 'false' 才关闭
  return localStorage.getItem(STORAGE_KEY) !== 'false';
}

export function setSnapEnabled(enabled) {
  localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new Event(SNAP_ENABLED_CHANGED));
}

// React Hook：返回 [enabled, toggle]，自动跟随广播同步
export function useSnapEnabled() {
  const [enabled, setEnabled] = useState(getSnapEnabled);
  useEffect(() => {
    const sync = () => setEnabled(getSnapEnabled());
    window.addEventListener(SNAP_ENABLED_CHANGED, sync);
    return () => window.removeEventListener(SNAP_ENABLED_CHANGED, sync);
  }, []);
  const toggle = () => setSnapEnabled(!getSnapEnabled());
  return [enabled, toggle];
}
